<template>
    <!-- insert label config form -->
    <div class="p-col-12 p-md-9 p-mx-auto p-mt-2">
        <div class="p-text-right">
            <Button
                label="Add New Config"
                v-show="serviceList !== undefined && serviceList !== null && serviceList.length > 0"
                @click="isNewConfigFormVisible = !isNewConfigFormVisible"
                class="p-button-sm p-button-text p-button-outlined p-button-info p-text-right" /> 
        </div>
    </div>

    <transition name="expand">
    <div v-show="isNewConfigFormVisible" class="p-grid p-jc-center p-p-4">
        <div class="card p-col-12 p-md-9 p-mx-auto p-p-4">
            <div class="p-grid">
                <div class="p-col-12 p-md-2">
                    <Dropdown class="p-text-left" style="width: 100% !important" placeholder="Select Service"
                    v-model="newConfigForm.service" :options="serviceList" optionLabel="name" optionValue="code" />
                </div>
                <div class="p-col-12 p-md-3">
                    <span class="p-float-label">
                        <InputText class="p-col-12" id="key" type="text" v-model="newConfigForm.label" />
                        <label for="key">Label</label>
                    </span>
                </div>
                <div class="p-col-12 p-md-3">
                    <span class="p-float-label">
                        <InputText class="p-col-12" id="value" type="text" v-model="newConfigForm.translated" />
                        <label for="value">Translated</label>
                    </span>
                </div>
                <div class="p-col-12 p-md-4">
                    <span class="p-float-label">
                        <Textarea class="p-col-12" id="comment" type="text" rows="2" :autoResize="true" v-model="newConfigForm.comment" />
                        <label for="comment">Comment</label>
                    </span>
                </div>
            </div>
            <div class="p-grid p-jc-end p-m-0 p-pt-2">
                <Button @click="addConfig()" label="Insert Label Config" class="p-button p-button-info" />
            </div>
        </div>
    </div>
    </transition>

    <ProgressBar mode="indeterminate" v-show="isItemListLoading" style="height: .2em" />

    <div class="p-grid">
    <div class="p-col-12 p-md-9 p-mx-auto p-mt-2">
      <DataTable v-show="configList !== null && configList.length > 0" :paginator="true" :rows="25" :rowHover="true"
        :value="configList" editMode="row" dataKey="id" v-model:filters="filters" filterDisplay="menu"
        v-model:editingRows="editingRows" @row-edit-save="onRowEditSave" responsiveLayout="scroll"
        :globalFilterFields="['id','service','label','translated','comment', 'last_updated_date']" >
          <Column field="id" header="#" sortable style="width:5%"></Column>
          <Column field="service" header="Service" sortable style="width:5%">
            <template #body="{data}">
              {{serviceName(data.service)}}
            </template>
            <template #editor="{data, field}">
              <Dropdown class="p-text-left" style="width: 100% !important" placeholder="Select Service"
                v-model="data[field]" :options="serviceList" optionLabel="name" optionValue="code" />
            </template>
          </Column>
          <Column field="label" header="Label" sortable style="width:20%">
            <template #body="{data}">
              {{data.label}}
            </template>
            <template #editor="{data, field}">
              <span class="p-float-label">
                <InputText v-model="data[field]" class="p-col-12" id="label" type="text" />
              </span>
            </template>
            <template #filter="{filterModel}">
              <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by Label"/>
            </template>
          </Column>
          <Column field="translated" header="Translated" sortable style="width:20%">
            <template #body="{data}">
              {{data.translated}}
            </template>
            <template #editor="{data, field}">
              <span class="p-float-label">
                <InputText v-model="data[field]" class="p-col-12" id="translated" type="text" />
              </span>
            </template>
            <template #filter="{filterModel}">
              <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by Translated"/>
            </template>
          </Column>
          <Column field="comment" header="Comment" style="width:20%">
            <template #body="{data}">
              <div v-html="getFormattedComment(data.comment)"></div>
            </template>
            <template #editor="{data, field}">
                <Textarea v-model="data[field]" rows="2" :autoResize="true" class="p-col-12" id="comment" />
            </template>
            <template #filter="{filterModel}">
              <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by Comment" />
            </template>
          </Column>
          <Column field="last_updated_date" header="Last Update" sortable dataType="date" class="p-text-center" style="width:15%; line-height: 1.25rem;">
            <template #body="{data}">
              <div v-html="getFormattedDate(data.last_updated_date)" style="width:100%"></div>
            </template>
            <template #editor="{}"></template>
          </Column>
          <Column :rowEditor="true" style="width:10%" bodyStyle="text-align:right;"></Column>
          <Column header="" style="width:5%" bodyStyle="text-align:left;">
            <template #body="item">
              <div style="">
                <Button label="" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-plain"
                  @click="deleteConfig(item.data.id)" />
              </div>
            </template>
            <template #editor="{}"></template>
          </Column>
      </DataTable>
    </div>
  </div>

</template>

<script>
import { FilterMatchMode, FilterOperator } from 'primevue/api';
import Dropdown from 'primevue/dropdown'
import ProgressBar from 'primevue/progressbar'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

import Const from '../utils/const'
import { isEmpty } from '../utils/utils'
import moment from 'moment';

export default {
    name: 'ConfigLabel',
    emits: ["loginResult", "pageLoaded"],
    components: {
        Dropdown, InputText, Textarea, Button, DataTable, ProgressBar, Column
    },
    data() {
        return {
            serviceList: [],
            isItemListLoading: false,
            configList: [],
            isNewConfigFormVisible: false,
            newConfigForm: {},
            editingRows: [],
            filters: {
                'service': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'label': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'translated': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'comment': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'last_updated_date': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]}
            }
        }
    },
    beforeMount() {
        var page = {
            title: "Label Config"
        }
        this.$emit('pageLoaded', page)
    },
    mounted() {
        this.loadServiceList()
    },
    methods: {
        loadServiceList() {
            let self = this,
                cookies = self.$cookies,
                toast = self.$toast,
                token = cookies.get('token');

            self.isItemListLoading = true
            self.$http.get('api/config/label/services', {
                headers: {
                'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                self.isItemListLoading = false
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    self.serviceList = response.data.items

                    self.loadConfig()
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Loading label services failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                self.isItemListLoading = false
                toast.add({severity:'error', summary: 'Error', detail:err});
                console.log(err)
            });
        },
        loadConfig() {
            let self = this,
                cookies = self.$cookies,
                toast = self.$toast,
                token = cookies.get('token');

            self.isItemListLoading = true
            self.$http.get('api/config/label', {
                headers: {
                'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                self.isItemListLoading = false
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    self.configList = response.data.items
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Loading label config failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                self.isItemListLoading = false
                toast.add({severity:'error', summary: 'Error', detail:err});
                console.log(err)
            });
        },
        serviceName(service) {
            var value = ''
            this.serviceList.forEach(item => {
                if(item.code === service)
                    value = item.name
            })

            return value
        },
        onRowEditSave(event) {
            let { newData, index } = event;

            let self = this,
                configId = newData.id,
                newConfig = {
                    id: configId,
                    service: newData.service,
                    label: newData.label,
                    translated: newData.translated,
                    comment: newData.comment
                },
                toast = self.$toast,
                toastMessage = null,
                cookies = self.$cookies,
                token = cookies.get('token');
            
            if(isEmpty(newConfig.service)) {
                toastMessage = 'Service is not selected!'
            } else if(isEmpty(newConfig.label)) {
                toastMessage = 'Label is empty!'
            } else if(isEmpty(newConfig.translated)) {
                toastMessage = 'Translated is empty!'
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            self.$http.put('api/config/label/'+configId, newConfig, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    
                    self.configList[index] = response.data.item;

                    toast.add({severity:'success', summary: 'Success', detail: 'Updated successfully.', life: 3000});
                } else {
                    toast.add({severity:'warn', summary: 'Update failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                console.log(err)
                toast.add({severity: 'error', summary: 'Error', detail: err});
            });
        },
        addConfig() {
            let self = this,
                toast = self.$toast,
                newConfigForm = self.newConfigForm,
                toastMessage = null,
                cookies = self.$cookies,
                token = self.$cookies.get('token');

            if(isEmpty(newConfigForm.service)) {
                toastMessage = 'Service is not selected!'
            } else if(isEmpty(newConfigForm.label)) {
                toastMessage = 'Label is empty!'
            } else if(isEmpty(newConfigForm.translated)) {
                toastMessage = 'Translated is empty!'
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            self.$http.post('api/config/label', newConfigForm, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    let newAddedItem = response.data.item
                    
                    self.configList.push(newAddedItem)

                    toast.add({severity:'success', summary: 'Success', detail: 'Label config added successfully.', life: 3000});

                    self.newConfigForm = {}
                } else {
                    console.log(response)
                    toast.add({severity:'warn', summary: 'Label config insert failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                console.log(err)
                toast.add({severity: 'error', summary: 'Error', detail: err});
            });
        },
        deleteConfig(configId) {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = self.$cookies.get('token');
            
            this.$confirm.require({
                message: 'Are you sure you want to delete this label config permanently?',
                header: 'Delete',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Delete',
                rejectLabel: 'Cancel',
                accept: () => {
                    self.$http.delete('api/config/label/'+configId, {
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                    })
                    .then(function (response) {
                    if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                        cookies.set("token", response.headers['refresh-token']);

                        self.loadConfig()

                        toast.add({severity:'success', summary: 'Success', detail: 'Label config deleted successfully.', life: 3000});
                    } else {
                        console.log(response)
                        toast.add({severity:'warn', summary: 'Label config category failed', detail:response.data.mesaj, life: 3000});
                    }
                    })
                    .catch(function (err) {
                    console.log(err)
                    toast.add({severity: 'error', summary: 'Error', detail: err});
                    });
                },
                reject: () => {
                }
            });
        },
        getFormattedDate(logDate) {
            return moment(new Date(logDate)).format('DD/MM/YYYY HH:mm');
        },
        getFormattedComment(comment) {
            return !isEmpty(comment) ? comment.replaceAll('\n', '<br/>') : null
        }
    }
}
</script>